export default "__VITE_ASSET__D_B_o0kU__"